import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@price-point/winston';
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/style.css';

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);

_.get(module, 'hot.accept', () => null)();
